import set from 'lodash/fp/set';
import { useTableDataState } from "./table-data.state";

export const usePagination = () => {
   const [query, setQuery, total] = useTableDataState((state) => [state.query, state.setQuery, state.total]);
   const { pageSize, offset } = query;
   const pageIndex = offset / pageSize;

   const setPageSize = (pageSize: number) =>  {
      localStorage.setItem("mmaPageSize", pageSize.toString())
      setQuery(set('pageSize', pageSize)(query));
   }
   const gotoPage = (page: number) => setQuery(set('offset', page * query.pageSize)(query));
   const nextPage = () => setQuery(set('offset', query.offset + query.pageSize)(query));
   const previousPage = () => setQuery(set('offset', query.offset - query.pageSize)(query));

   return { setPageSize, gotoPage, nextPage, previousPage, pageIndex, pageSize, total };
};
